module.exports = __webpack_public_path__ + "static/recruit_home__reason-bgr-mobile-809e38916694806614c545cc0a32b2c3.jpg";